import listSaga from './listSaga'
import oneSubscriptionSaga from './oneSubscriptionSaga'
import staticEnumsSaga from './staticEnumsSaga'

const subscriptionsSagas = [listSaga(), oneSubscriptionSaga(), staticEnumsSaga()]

export default subscriptionsSagas
